import Snippets from '../../services/snippets';

const state = {
  snippets: [],
  ready: true,
};

const actions = {
  async getSnippets(context) {
    const { owner } = context.rootState.user;
    context.commit('SET_SNIPPETS_READY', false);
    const data = owner ? await Snippets.getSnippets() : [];
    context.commit('SET_SNIPPETS', data?.snippets || []);
    return data?.snippets || [];
  },
};

const mutations = {
  /* eslint-disable no-shadow, no-param-reassign */

  SET_SNIPPETS(state, snippets) {
    state.snippets = snippets;
    state.ready = true;
  },

  SET_SNIPPETS_READY(state, ready) {
    state.ready = ready;
  },
};

export default {
  state,
  actions,
  mutations,
};
